import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GlobalRef } from '../../shared/globals/global-ref';
import { IActionResponse } from '../../shared/interfaces/models/iaction-response.model';
import { IEntityValidation } from '../../shared/interfaces/models/ientity-validation.model';
import { DictionaryBaseService } from '../../shared/services/dictionary-base.service';
import { UserContextService } from '../../shared/services/user-context.service';
import { IUser } from './iuser.model';
import { Departament } from './departament.model';

@Injectable({
  providedIn: 'root',
})
export class UsersService extends DictionaryBaseService<IUser> {
  constructor(
    globalContext: GlobalRef,
    protected userContextSvc: UserContextService,
    protected http: HttpClient
  ) {
    super(globalContext, userContextSvc, http);
    this.svcUrl += 'Users/';
  }

  getByLogin(login: string): Observable<IUser> {
    return this.http.get<IUser>(this.svcUrl + 'GetUserByLogin?login=' + login);
  }

  saveUserDetails(model: IUser): Observable<IActionResponse<number>> {
    return this.http.post<IActionResponse<number>>(
      this.svcUrl + 'SaveUserDetails',
      model
    );
  }

  searchAdUsers(query: string, take: number = 5): Observable<IUser[]> {
    return this.http.get<IUser[]>(
      this.svcUrl +
        `SearchAdUsers?query=${encodeURIComponent(query)}&take=${take}`
    );
  }

  resolveUser(input: string): Observable<IUser> {
    return this.http.get<IUser>(this.svcUrl + 'ResolveADUser?login=' + input);
  }

  getProfilePhotoByEmail(email: string): Observable<Blob> {
    return this.http.get(
      `${this.svcUrl}GetProfilePhotoByEmail?email=${encodeURIComponent(email)}`,
      {
        responseType: 'blob',
      }
    );
  }

  getDepartmentsHierarchy(login: string): Observable<Departament[]> {
    return this.http.get<Departament[]>(
      `${this.svcUrl}GetDepartmentsHierarchy?login=${login}`
    );
  }

  validate(model: IUser): IEntityValidation {
    let res: IEntityValidation = { Valid: true };
    let valid = !!model.Login;
    if (!valid) {
      res.Valid = false;
      res.Message = 'Не заполнены обязательные поля';
      return res;
    }
    return res;
  }
}
